import MailIcon from "@mui/icons-material/Mail";
import Badge from "@mui/material/Badge";
import Box from "@mui/material/Box";
import ButtonBase from "@mui/material/ButtonBase";
import type { ColumnDef } from "@tanstack/react-table";

import { TestIds } from "@storyboard/web-test-ids/testIds";
import { ampli } from "@/config";
import type { DriverRow } from "@/types/driver";
import type { DataTableFeatures } from "@/ui/dataTableFeatures";
import { zinc } from "@/ui/tokens";
import { redColor } from "@/utils/color";
import type { ColumnFilterOptions } from ".";

function UnreadIndicator({ unread }: { unread: boolean }) {
  if (!unread) {
    return <MailIcon sx={{ fontSize: 18, color: zinc[500] }} />;
  }

  return (
    <Badge
      variant="dot"
      overlap="circular"
      sx={{
        "& .MuiBadge-dot": {
          bgcolor: redColor,
          minWidth: 8,
          height: 8,
          top: 2,
          right: 2,
        },
      }}
    >
      <MailIcon sx={{ fontSize: 18, color: "white" }} />
    </Badge>
  );
}

function InboxHeader({ active, onToggle }: { active: boolean; onToggle: () => void }) {
  return (
    <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", width: "100%" }}>
      <ButtonBase
        onClick={() => {
          onToggle();
          ampli.toggleUnreadView();
        }}
        sx={{ borderRadius: 1, p: 0.25 }}
      >
        <UnreadIndicator unread={active} />
      </ButtonBase>
    </Box>
  );
}

export function inboxColumn(options: ColumnFilterOptions): ColumnDef<DataTableFeatures, DriverRow> {
  return {
    id: "inbox",
    header: () => <InboxHeader active={options.showUnreadOnly} onToggle={options.toggleUnreadOnly} />,
    cell: ({ row }) => (
      <Box
        data-sb={row.original.unread ? TestIds.driverView.rowUnreadDot : undefined}
        sx={{
          width: 10,
          height: 10,
          borderRadius: "50%",
          bgcolor: row.original.unread ? redColor : "transparent",
          mx: "auto",
        }}
      />
    ),
    meta: { flex: 0, compact: true, frozen: true, alwaysPinned: true },
    size: 28,
    minSize: 28,
    maxSize: 28,
    enableSorting: false,
    enableGlobalFilter: false,
    enableResizing: false,
    enableHiding: false,
  };
}
